import { MarkerClusterer } from "@googlemaps/markerclusterer";

document.addEventListener("DOMContentLoaded", function () {
  var map;
  var map_loaded = false;

  function initMap() {
    let locations = contact_location.markers;
    let mapOptions = Object.assign(contact_location.settings, { styles: JSON.parse(contact_location.styles) }, { zoom: innerWidth < 768 ? 6 : 7 });
    let labels = [];
    var marker_ids = [];

    if (!window_loaded) return true;
    if (map_loaded) return true;

    var el = document.getElementById("map");
    if (!el || !$(el).is(":visible")) {
      return true;
    }
    var $window = $(window),
      windowHeight = $window.height(),
      windowScrollTop = $window.scrollTop();

    if ($(el).offset().top - windowScrollTop > windowHeight * 1) return true;

    map_loaded = true;

    var map = new google.maps.Map(document.getElementById("map"), mapOptions);

    var infoWindow = new google.maps.InfoWindow({
      content: "Frmutil HS S.A.",
    });

    const markers = locations.map((location, i) => {
      const label = location.title;
      const marker = new google.maps.Marker({
        position: location.cords,
        icon: contact_location.pin,
        id: `marker_${i}`,
      });
      marker.addListener("click", () => {
        infoWindow.setContent(label);
        infoWindow.open(map, marker);
      });
      return marker;
    });
    var pinDir = "/wp-content/themes/farmutil/resources/img/m/";
 
    const svg = window.btoa(`
                <svg fill="#edba31" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <circle cx="120" cy="120" opacity="1" r="70" />
                <circle cx="120" cy="120" opacity=".7" r="90" />
                <circle cx="120" cy="120" opacity=".3" r="110" />
                <circle cx="120" cy="120" opacity=".2" r="130" />
                </svg>`);
    const renderer = {
      render: ({ count, position }) =>
        new google.maps.Marker({
          label: { text: String(count), color: "#fff", fontSize: "16px", fontWeight: "600" },
          icon: {
            // url: `data:image/svg+xml;base64,${svg}`,
            url: `${window.location.origin}/wp-content/themes/farmutil/resources/img/m/1.png`,
            scaledSize: new google.maps.Size(30, 38),
          },
          position,
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        }),
    };
    new MarkerClusterer({ markers, map, renderer });
  }

  $("body").show();
  window_loaded = true;
  initMap();

  $(window).resize(function () {
    initMap();
  });

  $(window).scroll(function () {
    initMap();
  });
});
